import { defineRouting } from 'next-intl/routing'
import { APP_DEFAULT_LOCALE, APP_LOCALES } from '@/constants/i18n.constants'

export const routing = defineRouting({
	// A list of all supported locales
	locales: APP_LOCALES,
	defaultLocale: APP_DEFAULT_LOCALE,
	pathnames: {
		'/': '/',
		'/blog': {
			de: '/blog',
			es: '/blog',
			fr: '/blog',
		},
		'/blog/search': {
			de: '/blog/suche',
			es: '/blog/buscar',
			fr: '/blog/recherche',
		},
		'/blog/page/[page]': {
			de: '/blog/seite/[page]',
			es: '/blog/pagina/[page]',
			fr: '/blog/page/[page]',
		},
		'/blog/[slug]': {
			de: '/blog/[slug]',
			es: '/blog/[slug]',
			fr: '/blog/[slug]',
		},
		'/blog/category/[slug]': {
			de: '/blog/kategorie/[slug]',
			es: '/blog/categoria/[slug]',
			fr: '/blog/categorie/[slug]',
		},
		'/blog/category/[slug]/page/[page]': {
			de: '/blog/kategorie/[slug]/seite/[page]',
			es: '/blog/categoria/[slug]/pagina/[page]',
			fr: '/blog/categorie/[slug]/page/[page]',
		},
		'/blog/author/[slug]': {
			de: '/blog/autor/[slug]',
			es: '/blog/autor/[slug]',
			fr: '/blog/auteur/[slug]',
		},
		'/blog/author/[slug]/page/[page]': {
			de: '/blog/autor/[slug]/seite/[page]',
			es: '/blog/autor/[slug]/pagina/[page]',
			fr: '/blog/auteur/[slug]/page/[page]',
		},
		'/case-studies': {
			de: '/fallstudien',
			es: '/casos-de-uso',
			fr: '/etudes-de-cas',
		},
		'/case-studies/[slug]': {
			de: '/fallstudien/[slug]',
			es: '/casos-de-uso/[slug]',
			fr: '/etudes-de-cas/[slug]',
		},
		'/product/apps': {
			de: '/produkt/apps',
			es: '/producto/apps',
			fr: '/produit/apps',
		},
		'/product/apps/[category]': {
			de: '/produkt/apps/[category]',
			es: '/producto/apps/[category]',
			fr: '/produit/apps/[category]',
		},
		'/product/apps/[category]/[slug]': {
			de: '/produkt/apps/[category]/[slug]',
			es: '/producto/apps/[category]/[slug]',
			fr: '/produit/apps/[category]/[slug]',
		},
	},
	// automatic http-header alternate link creation disabled, we create hreflang attributes in html
	alternateLinks: false,
	localeDetection: false,
	localePrefix: 'as-needed',
})
